import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import useTranslation from 'next-translate/useTranslation';
import { combineClassNames } from '@arkestro/arkestro-design-system';

import styles from './InputPhone.module.scss';

/** @type {(...args: any[]) => void} */
const noop = () => {};

const InputPhone = ({ error = '', value = '', onChange = noop }) => {
  const { t } = useTranslation('common');

  const handleChange = (eventValue, countryData) => {
    onChange({ target: { name: 'phone', value: eventValue } }, countryData);
  };

  return (
    <div className={combineClassNames(styles.container, error && styles.invalid)}>
      <label className={styles.label} htmlFor='phone'>{t('general.phone')}</label>
      <PhoneInput
        country='us'
        countryCodeEditable={false}
        disableSearchIcon
        dropdownClass='standard-scrollbar standard-phone-dropdown'
        enableLongNumbers
        enableSearchField
        inputClass='phone-input'
        inputExtraProps={{
          name: 'phone'
        }}
        inputProps={{
          autoComplete: 'off'
        }}
        onChange={handleChange}
        placeholder=''
        preferredCountries={['us', 'cn', 'de']}
        value={value.replace(/\D/g, '')} // remove non-numeric characters
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

InputPhone.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default InputPhone;
